import {
  Button,
  Card,
  Checkbox,
  Form,
  Input,
  message,
  Select,
  Image,
  Typography,
  Alert,
} from "antd";
import md5 from "md5";
import User from "models/user/user";
import qs from "qs";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import RecoveryPassword from "assets/images/recovery-password.png";

import {
  deleteQueryParam,
  downloadEvent,
  redirectToUrl,
  setFieldErrorsFromServer,
} from "utilities/generalUtility";
import Logo from "assets/images/logo.svg";
import LogoBackground from "assets/images/diary-bg-img.jpg";
import ArrowImage from "assets/images/arrow-img.svg";
import { ExclamationCircleFilled } from "@ant-design/icons";

export default function ForgetPassword() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [btnLoading, setBtnLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [isError, setIsError] = useState({ status: false, message: "" });
  const paramJson = qs.parse(location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    if (paramJson.err) {
      message.error(paramJson.err);
      deleteQueryParam("err");
    }
  }, []);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const onFinish = async (values) => {
    // const encryptedPass = md5(values.password);
    try {
      setBtnLoading(true);
      const res = await User.forgotPassword(values?.email);
      setBtnLoading(false);
      setIsError((prev) => {
        return {
          ...prev,
          status: false,
          message: "",
        };
      });

      // await dispatch(
      //   User.loginCall(values.email, encryptedPass, values.remember)
      // );
      // redirectToUrl("/");
    } catch (error) {
      setBtnLoading(false);
      setIsError((prev) => {
        return {
          ...prev,
          status: true,
          message: error.message,
        };
      });
      error?.statusCode === 403 && showModal();
      setFieldErrorsFromServer(error, form, values);
    }
  };

  const { Title, Paragraph } = Typography;

  return (
    <React.Fragment>
      <div className="login-container d-flex">
        <div className="login-bg w-100">
          <img className="login-img w-100 h-100" src={LogoBackground} alt="" />
        </div>
        <Card bordered={false} className="login-card password-reset">
          <div className="authentication-logo text-center">
            <img className="logo" src={Logo} alt="" />
          </div>
          <Title level={4}>Password Recovery</Title>
          <div className="recovery-img text-center">
            <img src={RecoveryPassword} alt="" />
            <Paragraph className="mb-0">
              please enter the email address link to this account
            </Paragraph>
          </div>
          {isError.status && (
            <Alert
              className="custom-alert"
              description={isError.message}
              // description={
              //   <p className="mb-0">
              //     Let’s create a new account for{" "}
              //     <strong> example.example@example.com</strong>
              //   </p>
              // }
              showIcon
              icon={<ExclamationCircleFilled />}
            />
          )}
          <Form
            form={form}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            layout="vertical"
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your Email!",
                },
              ]}
            >
              <Input
                type="email"
                suffix={<i className="icon-email site-form-item-icon"></i>}
                placeholder="email"
                size="large"
              />
            </Form.Item>
            <Form.Item className="mb-4">
              <Button
                block
                size="large"
                type="primary"
                htmlType="submit"
                loading={btnLoading}
                onClick={() => {
                  downloadEvent("ForgotPassword");
                }}
              >
                Continue
              </Button>
            </Form.Item>
            <Title level={5} className="text-center">
              Remember your password?
              <Link to="/login">Login</Link>
            </Title>
          </Form>
        </Card>
      </div>
    </React.Fragment>
  );
}
